import React from "react";
import Popup from "../Popup/Popup";
import { Btn } from "../../styles/Button.styled";
import { Container } from "../../styles/Sidebar/UploadModal.styled";

export function NotReadyToSignModal({
  docs,
  onClose,
}: {
  docs: string[];
  onClose: () => void;
}) {
  return (
    <Popup clickCloseButton={onClose} style={{ height: "max-content" }}>
      <h1>Документи не готові до підпису</h1>
      <Container>
        <div style={{ marginBottom: "20px", color: "var(--text-main, #333)", fontSize: "14px", lineHeight: "1.5" }}>
          <p style={{ marginBottom: "10px" }}>
            {docs.length === 1
              ? "Документ не має заповненого типу або обов'язкових атрибутів:"
              : `${docs.length} документи не мають заповненого типу або обов'язкових атрибутів:`}
          </p>
          <div style={{
            backgroundColor: "var(--disabled-bg)",
            padding: "10px 14px",
            borderRadius: "8px",
            maxHeight: "40vh",
            overflowY: "auto",
            marginTop: "20px",
          }}>
            {docs.map((title, index) => (
              <div key={index} style={{ marginBottom: "4px", display: "flex", gap: "6px" }}>
                <span style={{ fontWeight: "500", color: "var(--disabled-btn-bg)", minWidth: "20px" }}>
                  {index + 1}.
                </span>
                <span style={{ wordBreak: "break-all" }}>{title}</span>
              </div>
            ))}
          </div>
        </div>
        <Btn
          type="button"
          $width="100%"
          $color="var(--blue)"
          $marginTop="0"
          onClick={onClose}
          $background="var(--sidebar-hover)"
          $heightMobile="47px"
        >
          Close
        </Btn>
      </Container>
    </Popup>
  );
}

interface ConfirmModalProps {
  docs: string[] | string;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmModal({
  onConfirm,
  onClose,
  docs,
}: ConfirmModalProps) {
  const isMultiple = Array.isArray(docs);
  const docsCount = isMultiple ? docs.length : 1;
  return (
    <Popup clickCloseButton={onClose} style={{ height: "max-content" }}>
      <h1>Видалення документів</h1>
      <Container>
        <div
          style={{
            marginBottom: "20px",
            color: "var(--text-main, #333)",
            fontSize: "14px",
            lineHeight: "1.5",
          }}
        >
          <p style={{ marginBottom: "10px" }}>
            Ви дійсно бажаєте безповоротно видалити{" "}
            {isMultiple
              ? `обрані документи (${docsCount} шт.)`
              : "цей документ"}
            ? Цю дію не можна буде скасувати.
          </p>

          <div
            style={{
              backgroundColor: "var(--disabled-bg)",
              padding: "10px 14px",
              borderRadius: "8px",
              maxHeight: "40vh",
              overflowY: "auto",
              marginTop: "20px",
            }}
          >
            {isMultiple ? (
              <div
                style={{
                  margin: 0,
                  paddingLeft: "8px",
                  fontSize: "13px",
                  color: "rgb(85, 85, 85)",
                }}
              >
                {(docs as string[]).map((el, index) => (
                  <div
                    key={index}
                    style={{ marginBottom: "4px", display: "flex", gap: "6px" }}
                  >
                    <span
                      style={{
                        fontWeight: "500",
                        color: "var(--disabled-btn-bg)",
                        minWidth: "20px",
                      }}
                    >
                      {index + 1}.
                    </span>
                    <span style={{ wordBreak: "break-all" }}>{el ?? ""}</span>
                  </div>
                ))}
              </div>
            ) : (
              <span style={{ fontWeight: "bold" }}>📄 {docs}</span>
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            $marginTop="0"
            style={{ flex: 1 }}
            onClick={onClose}
            $background="var(--sidebar-hover)"
            $heightMobile="47px"
          >
            Відмінити
          </Btn>

          <Btn
            style={{ flex: 1 }}
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            onClick={onConfirm}
            $background="var(--vivid-pink)"
            $heightMobile="47px"
          >
            Видалити
          </Btn>
        </div>
      </Container>
    </Popup>
  );
}
